export const primaryTextColor = '#1D1C1D';